<template>
  <div>
    <v-dialog
      v-model="dialog.show"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">{{ dialog.title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-6 pt-2" align="center">
          <v-icon size="80" color="info">
            mdi-help-circle
          </v-icon>
          <div class="font-weight-medium text-body-1 mt-2 grey--text text--darken-4 mb-7">
            {{ dialog.body }}
          </div>

          <v-btn
            class="mr-4"
            color="darken-1 mb-4 px-14"
            depressed
            rounded
            large
            v-if="!dialog.cancelBtnWithAction"
            @click="dialog.show = false"
          >
            {{ dialog.cancelBtn }}
          </v-btn>

          <v-btn
            class="mr-4"
            color="darken-1 mb-4 px-14"
            depressed
            rounded
            large
            v-if="dialog.cancelBtnWithAction"
            @click="doCancel()"
          >
            {{ dialog.cancelBtn }}
          </v-btn>

          <v-btn
            color="primary darken-1 mb-4 px-14"
            depressed
            rounded
            large
            @click="doConfirm()"
          >
            {{ dialog.confirmBtn }}
          </v-btn>

        </v-card-text>


      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'confirmation-dialog',
    props: ['dialog'],
    data: () => ({
    }),
    computed: {
    },
    methods: {
      doConfirm (){
        this.$emit('doConfirm')
      },
      doCancel (){
        this.$emit('doCancel')
      },
    },
    mounted() {
    },
    components: {
    }
  }
</script>
